<div class="clinic-history-shared-wrapper">
    <button mat-stroked-button color="accent" (click)="onClickShareButton()">        
        {{ 'shared.clinicHistory.shareComponent.text1' | translate:locale.language | uppercase }}
    </button>
    <mat-icon color="accent" fontSet="phr-iconset" class="phr-iconset-download" (click)="onClickShareButton()"></mat-icon>
</div>
